<section class="error-page card">
  <div class="card-body">
    <h2 class="title">{{ "errorPage.title" | translate }}</h2>
    <p class="description">
      {{ "errorPage.description" | translate }}
    </p>

    <button type="button" class="btn btn-primary mt-3" (click)="goToProjects()">
      {{ "errorPage.goToProjects" | translate }}
    </button>
  </div>
</section>
